import React, { useState } from "react"
import Typewriter from "typewriter-effect"
import { Link } from "gatsby"

interface HeaderProps {
  siteTitle?: string
}

const Header: React.FC<HeaderProps> = ({ siteTitle = "" }) => {
  const [isLoaded, setIsLoaded] = useState<string | boolean>(
    typeof window !== "undefined"
      ? sessionStorage.getItem("isLoaded") || false
      : false
  )

  return (
    <header>
      <div style={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}>
        <h1>
          {isLoaded ? (
            <Link
              to="/"
              style={{
                color: "inherit",
                borderBottom: "none",
                fontFamily: "inherit",
              }}
            >
              Ayemun <em>Hossain</em>
            </Link>
          ) : (
            <Typewriter
              options={{ deleteSpeed: "natural" as any }}
              onInit={typewriter => {
                typewriter
                  .typeString("Senior Backend Engineer")
                  .pauseFor(1600)
                  .deleteAll()
                  .typeString("AI · RAG · Vectors")
                  .pauseFor(1600)
                  .deleteAll()
                  .typeString("DevSecOps Practitioner")
                  .pauseFor(1600)
                  .deleteAll()
                  .typeString("Ayemun Hossain")
                  .callFunction(() => {
                    setIsLoaded(true)
                  })
                  .start()
              }}
            />
          )}
        </h1>
        <span
          style={{
            fontFamily: "var(--fontMono)",
            fontSize: "0.78rem",
            letterSpacing: "1.5px",
            color: "var(--textDim)",
            textTransform: "uppercase",
          }}
        >
          Backend · Cloud · AI · DevSecOps
        </span>
      </div>
    </header>
  )
}

export default Header
